// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.menu_menu_yWEXA {
  position: absolute;
  border: 1px solid var(--ui-black-transparent);
  border-radius: 0 0 8px 8px;
  background-color: var(--menu-bar-background);
  padding: 0;
  margin: 0;
  min-width: 186px;
  overflow: visible;
  box-shadow: 0 8px 8px 0 var(--shadow);
}

.menu_menu_yWEXA.menu_left_wI2Ul {
  right: 0;
}

.menu_menu_yWEXA.menu_right_I_TGJ {
  left: 0;
}

.menu_menu-item_gPEdE {
  display: block;
  line-height: 34px;
  white-space: nowrap;
  padding: 0 10px;
  font-size: 0.75rem;
  margin: 0;
  font-weight: bold;
  position: relative;
}

.menu_menu-item_gPEdE.menu_active_RRVex,
.menu_menu-item_gPEdE:hover,
.menu_menu-item_gPEdE.menu_expanded_lnDz9 {
  background-color: var(--ui-black-transparent);
}

.menu_menu-item_gPEdE.menu_hoverable_pr1Yb {
  cursor: pointer;
}

.menu_menu-section_s_GGT {
  border-top: 1px solid var(--ui-black-transparent);
}

.menu_submenu_EvKZT {
  display: none;
  position: absolute;
  top: -1px;
  min-width: 186px;
  height: -webkit-max-content;
  height: max-content;
  overflow: hidden;
  border-radius: 8px;
}

.menu_submenu_EvKZT.menu_right_I_TGJ {
  left: 100%;
}

.menu_submenu_EvKZT.menu_left_wI2Ul {
  right: 100%;
}

.menu_submenu_EvKZT > .menu_menu_yWEXA {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: var(--menu-bar-foreground) var(--menu-bar-background);
  border-radius: 8px;
}

.menu_menu-item_gPEdE.menu_expanded_lnDz9 > .menu_submenu_EvKZT {
  display: block;
}

:not(:has(> .menu_menu-item_gPEdE.menu_expanded_lnDz9)) > .menu_menu-item_gPEdE:hover > .menu_submenu_EvKZT {
  display: block;
}

/* Fallback styling for webkit browsers that don't support scrollbar-color */

.menu_submenu_EvKZT > .menu_menu_yWEXA::-webkit-scrollbar {
  width: 12px;
}

.menu_submenu_EvKZT > .menu_menu_yWEXA::-webkit-scrollbar-track {
  background: var(--menu-bar-background);
}

.menu_submenu_EvKZT > .menu_menu_yWEXA::-webkit-scrollbar-thumb {
  background-color: var(--menu-bar-foreground);
  border-radius: 12px;
  border: 3px solid var(--menu-bar-background);
}
`, "",{"version":3,"sources":["webpack://./src/components/menu/menu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,4CAA4C;EAC5C,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;;AAE5E;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,4CAA4C;AAC9C","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.menu {\n  position: absolute;\n  border: 1px solid var(--ui-black-transparent);\n  border-radius: 0 0 8px 8px;\n  background-color: var(--menu-bar-background);\n  padding: 0;\n  margin: 0;\n  min-width: 186px;\n  overflow: visible;\n  box-shadow: 0 8px 8px 0 var(--shadow);\n}\n\n.menu.left {\n  right: 0;\n}\n\n.menu.right {\n  left: 0;\n}\n\n.menu-item {\n  display: block;\n  line-height: 34px;\n  white-space: nowrap;\n  padding: 0 10px;\n  font-size: 0.75rem;\n  margin: 0;\n  font-weight: bold;\n  position: relative;\n}\n\n.menu-item.active,\n.menu-item:hover,\n.menu-item.expanded {\n  background-color: var(--ui-black-transparent);\n}\n\n.menu-item.hoverable {\n  cursor: pointer;\n}\n\n.menu-section {\n  border-top: 1px solid var(--ui-black-transparent);\n}\n\n.submenu {\n  display: none;\n  position: absolute;\n  top: -1px;\n  min-width: 186px;\n  height: -webkit-max-content;\n  height: max-content;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.submenu.right {\n  left: 100%;\n}\n\n.submenu.left {\n  right: 100%;\n}\n\n.submenu > .menu {\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-color: var(--menu-bar-foreground) var(--menu-bar-background);\n  border-radius: 8px;\n}\n\n.menu-item.expanded > .submenu {\n  display: block;\n}\n\n:not(:has(> .menu-item.expanded)) > .menu-item:hover > .submenu {\n  display: block;\n}\n\n/* Fallback styling for webkit browsers that don't support scrollbar-color */\n\n.submenu > .menu::-webkit-scrollbar {\n  width: 12px;\n}\n\n.submenu > .menu::-webkit-scrollbar-track {\n  background: var(--menu-bar-background);\n}\n\n.submenu > .menu::-webkit-scrollbar-thumb {\n  background-color: var(--menu-bar-foreground);\n  border-radius: 12px;\n  border: 3px solid var(--menu-bar-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `menu_menu_yWEXA`,
	"left": `menu_left_wI2Ul`,
	"right": `menu_right_I_TGJ`,
	"menu-item": `menu_menu-item_gPEdE`,
	"menuItem": `menu_menu-item_gPEdE`,
	"active": `menu_active_RRVex`,
	"expanded": `menu_expanded_lnDz9`,
	"hoverable": `menu_hoverable_pr1Yb`,
	"menu-section": `menu_menu-section_s_GGT`,
	"menuSection": `menu_menu-section_s_GGT`,
	"submenu": `menu_submenu_EvKZT`
};
export default ___CSS_LOADER_EXPORT___;
